export default __webpack_public_path__ + "static/media/bell-solar-logo.38aad115.png";